
<div class="bi-post-action">
  <div v-for="data in actionData" :key="data.id" class="mb-2">
    <div>
      <div class="label mt-2">{{ data.displayName || data.fieldName }}</div>
      <p class="" v-if="data.description">{{ data.description }}</p>
    </div>
    <div v-if="data.type === actionType.Input">
      <ValidationProvider :name="data.fieldName" v-slot="{ errors }" :rules="getInputRules(data)">
        <input type="text" class="form-control" v-model="data.value"  />
        <div v-if="errors[0]" class="alert alert-danger" role="alert">{{ errors[0] }} Max length is {{ data.rules.length }}</div>
      </ValidationProvider>
    </div>
    <div v-if="data.type === actionType.MinMax">
      <ValidationProvider v-slot="{ errors }" :name="data.fieldName" :rules="getMinMaxRules(data)">
        <input :name="data.fieldName" type="number" class="form-control" v-model="data.value" />

        <div v-if="errors[0]" class="alert alert-danger" role="alert">{{ errors[0] }} Max value is {{ data.rules.max }}</div>
      </ValidationProvider>
    </div>
    <div v-if="data.type === actionType.FromToDate">
      <ValidationProvider :name="data.fieldName" :rules="getRequiredRule(data)">
        <input type="text" v-show="false" v-model="data.value" />
      </ValidationProvider>

      <ActionDate :name="data.fieldName" :actionData="data"></ActionDate>
      <div v-if="!data.value && data.rules.isRequired" class="alert alert-danger" role="alert">{{ data.fieldName }} is required</div>
    </div>
    <div v-if="data.type === actionType.TextArea">
      <ValidationProvider :name="data.fieldName" v-slot="{ errors }" :rules="getTextAreaRules(data)">
        <textarea-autosize class="area form-control" v-model="data.value" :min-height="30"></textarea-autosize>

        <div v-if="errors[0]" class="alert alert-danger" role="alert">{{ errors[0] }} Max length is {{ data.rules.length }}</div>
      </ValidationProvider>
    </div>

    <div v-if="data.type === actionType.Checkbox || data.type === actionType.IncludeImages">
      <ValidationProvider :name="data.fieldName">
        <b-form-checkbox class="mb-1" v-model="data.value" :value="true" :unchecked-value="false">
          {{data.displayName || data.fieldName}}
        </b-form-checkbox>
      </ValidationProvider>
    </div>

    <div v-if="data.type === actionType.Multiselect">
      <ValidationProvider :name="data.fieldName">
        <action-multi-select :action-data="data" v-model="data.value"></action-multi-select>
      </ValidationProvider>
    </div>
  </div>
</div>
